import React from "react";
import { Alert, Icon, message } from "antd";
import { connect } from "react-redux";

import { getEmailTemplateByIDRequest } from "../../../api/requests";

import EmailTemplatesForm from "./EmailTemplatesForm";

import get from "lodash/get";
import { logout } from "../../../reducers/user/actions";

class EmailTemplatesFormWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailTemplate: null,
      isLoading: false,
      requestResult: null,
    };
  }

  async componentDidMount() {
    this.getEmailTemplate();
  }

  getEmailTemplate = async () => {
    if (this.props.id) {
      this.setState({ isLoading: true });
      try {
        const { data } = await getEmailTemplateByIDRequest(this.props.id);
        this.setState({
          emailTemplate: data,
        });
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
          return;
        }
        message.error(get(e, "response.data.error", "Error"));
      }

      this.setState({ isLoading: false });
    } else {
      this.setState({
        emailTemplate: {},
      });
    }
  };

  render() {
    const { isLoading, emailTemplate } = this.state;
    return (
      <div>
        {isLoading && <Icon type="loading" />}
        {emailTemplate && (
          <EmailTemplatesForm
            isNew={emailTemplate && !emailTemplate.id}
            {...this.props}
            {...emailTemplate}
            onReset={() => {
              this.setState(
                {
                  emailTemplate: null,
                  isLoading: false,
                  requestResult: null,
                },
                () => {
                  this.getEmailTemplate();
                }
              );
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { logout };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailTemplatesFormWrapper);



// WEBPACK FOOTER //
// ./src/containers/EmailTemplates/EmailTemplatesForm/EmailTemplatesFormWrapper.js